import { useCallback, useMemo, useState } from 'react';
import constants from '../../config/constants';

const { AVAILABILITY_PICKUPINSTORE, AVAILABILITY_STOCKINSTORE, AVAILABILITY_HOMEDELIVERY } = constants;

const useDeliveryDataPersistence = () => {
  const [pickupInStoreData, setPickupInStoreDataState] = useState([]);
  const [homeDeliveryData, setHomeDeliveryDataState] = useState([]);
  const [storesList, setStoresListState] = useState([]);
  const [selectedType, setSelectedType] = useState('');
  const [textGenerated, setTextGenerated] = useState({
    StockInStore: {},
    HomeDelivery: {},
    PickupInStore: {},
  });

  const [deliveryErrors, setDeliveryErrors] = useState({
    PickupInStore: { isError: false, code: null },
    HomeDelivery: { isError: false, code: null },
    StockInStore: { isError: false, code: null },
  });

  const setPickupInStoreData = useCallback((data) => {
    setPickupInStoreDataState(data);
  }, []);

  const setHomeDeliveryData = useCallback((data) => {
    setHomeDeliveryDataState(data);
  }, []);

  const setStoresList = useCallback((data) => {
    setStoresListState(data);
  }, []);

  const clearDeliveryData = useCallback(() => {
    setPickupInStoreDataState([]);
    setHomeDeliveryDataState([]);
    setStoresListState([]);
  }, []);

  const setDeliveryError = useCallback((deliveryType, hasError, errorCode = null) => {
    const typeMap = {
      [AVAILABILITY_PICKUPINSTORE]: 'PickupInStore',
      [AVAILABILITY_HOMEDELIVERY]: 'HomeDelivery',
      [AVAILABILITY_STOCKINSTORE]: 'StockInStore',
    };

    const errorKey = typeMap[deliveryType];
    if (!errorKey) return;

    setDeliveryErrors((prev) => ({
      ...prev,
      [errorKey]: {
        isError: hasError,
        code: hasError ? errorCode : null,
      },
    }));
  }, []);

  const clearDeliveryErrors = useCallback(() => {
    setDeliveryErrors({
      PickupInStore: { isError: false, code: null },
      HomeDelivery: { isError: false, code: null },
      StockInStore: { isError: false, code: null },
    });
  }, []);

  const deliveryData = useMemo(
    () => ({
      pickupInStoreData,
      homeDeliveryData,
      storesList,
    }),
    [pickupInStoreData, homeDeliveryData, storesList]
  );

  const deliveryActions = useMemo(
    () => ({
      setPickupInStoreData,
      setHomeDeliveryData,
      setStoresList,
      clearDeliveryData,
      setTextGenerated,
      setDeliveryError,
      clearDeliveryErrors,
    }),
    [
      setPickupInStoreData,
      setHomeDeliveryData,
      setStoresList,
      clearDeliveryData,
      setTextGenerated,
      setDeliveryError,
      clearDeliveryErrors,
    ]
  );

  return {
    deliveryData,
    deliveryActions,
    selectedType,
    setSelectedType,
    textGenerated,
    deliveryErrors,
  };
};

export default useDeliveryDataPersistence;
